import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import * as Flash from '../../components/flash-message'
import * as Constants from './constants'

export const epic = ReduxObservable.combineEpics(
  Flash.createFlashSuccessEpic(Constants.UPDATE_OR_CREATE_CONFIG, 'Configuration saved'),
  Flash.createFlashErrorEpic('LOGO_IMPORT', 'TOO BIG'),
)



// WEBPACK FOOTER //
// ./src/pages/newsbrief/epic.ts